<template>
  <!-- AD-104 : classe autocomplete-field pour réserver la place de la croix dans le champ -->
  <div class="position-relative autocomplete-field" v-bind:class="{ 'open': openSuggestion }">
    <input
        class="form-control"
        type="text"
        v-model="selection"
        @focus="focus"
        @keydown.enter="enter"
        @keydown.esc="close"
        @keydown.down="down"
        @keydown.up="up"
        @input="change"
        :placeholder="placeholder"
    />
    <b-icon class="icon-x-filter" icon="x" font-scale="1.5" v-on:click="cancelResearch"></b-icon>
    <div
        class="position-absolute w-100"
        v-if="openSuggestion"
    >
      <div class="card card-search-autocomplete">
        <div class="d-flex justify-content-between">
            <span class="pt-1 pl-1 pb-2">
              {{ $t('common.search.result') }}
              <b>{{ matches.length }}</b> {{ researchLabel }}
            </span>
        </div>
        <hr class="p-0 m-0">
        <div class="card-body p-0">
          <div class="" v-for="(suggestion, index) in matches" :key="index">
            <template v-if="!isListingPage">
              <b-form-checkbox
                  class="mb-3 ml-3 mt-3"
                  :key="index"
                  :checked="(!isListingPage) ? (listId.includes(suggestion.id)) : false"
                  @change="suggestionClick($event, index)"
              >
                {{ suggestion.searchable }}
              </b-form-checkbox>
            </template>
            <template v-else>
              <!-- AD-104 : un résultat déjà filtré est coché, un clic dessus retire le filtre -->
              <div class="autocomplete-result c-pointer w-100 p-2" @click="suggestionClick($event, index)"
                   :class="{ 'autocomplete-result-selected': selectedIds.includes(suggestion.id) }"
                   :title="selectedIds.includes(suggestion.id) ? $t('common.search.alreadyFiltered') : null">
                <b-icon v-if="selectedIds.includes(suggestion.id)" icon="check2-square" class="mr-1"></b-icon>{{ suggestion.searchable }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      selection: '',
      current: 0,
      selectedSuggestions: []
    }
  },
  props: {
    isListingPage: {
      type: Boolean,
      required: true
    },
    suggestions: {
      type: Array,
      required: true
    },
    // AD-104 : identifiants déjà filtrés (pages de liste), affichés cochés, un clic les retire
    selectedIds: {
      type: Array,
      default: () => []
    },
    listId: {
      type: Array,
      required: false
    },
    researchLabel: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    entity: {
      type: String,
      required: true
    }
  },
  // AD-104 : un clic en dehors du champ et de sa liste referme la liste des résultats
  mounted() {
    document.addEventListener('mousedown', this.clickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.clickOutside)
  },
  watch: {
    selection(newValue) {
      this.selection = newValue
    }
  },
  methods: {
    // AD-104 : referme la liste (clic extérieur, touche Échap)
    close() {
      this.isOpen = false
    },
    // AD-104 : clic ailleurs que dans ce composant
    clickOutside(event) {
      // AD-104 : dans une liste déroulante (tableau de bord), défiler ou cocher dans cette liste ne ferme pas les résultats
      const zone = (this.$el && this.$el.closest('.dropdown-menu')) || this.$el // AD-104
      if (this.isOpen && zone && !zone.contains(event.target)) {
        this.close()
      }
    },
    // When focus on the input
    focus() {
      if(this.isListingPage) {
        this.isOpen = true;
      }
    },

    // When enter pressed on the input
    enter() {
      // N'appliquer le filtre que si le menu de suggestions est ouvert et non vide.
      // openSuggestion garantit selection !== '' ET matches.length !== 0 → pas de crash, pas de filtre au hasard.
      if (!this.openSuggestion) {
        return;
      }
      // Borne l'index courant aux résultats réellement affichés (matches, pas suggestions).
      const index = Math.min(this.current, this.matches.length - 1);
      // Émet exactement le même événement qu'un clic sur la proposition.
      this.suggestionClick(true, index);
      this.isOpen = false;
    },

    // When up pressed while suggestions are open
    up() {
      if(this.current > 0)
        this.current--
    },

    // When down pressed while suggestions are open
    down() {
      if(this.current < this.matches.length - 1)
        this.current++
    },

    // For highlighting element
    isActive(index) {
      return index === this.current
    },

    // When the user changes input
    change() {
      if (this.isOpen === false) {
        this.isOpen = true
        this.current = 0
      }
    },

    cancelResearch() {
      this.selection = ''
    },

    // When one of the suggestion is clicked
    suggestionClick(event, index) {
      let model = {
        checked: event,
        result: this.matches[index],
        entity: this.entity
      }

      this.$emit('click-suggestion', model)

      // AD-104 : sur une page de liste, le clic sur un résultat applique le filtre et referme la liste, comme la touche Entrée ;
      // sur le tableau de bord la liste reste ouverte, on y coche plusieurs revendeurs d'affilée
      if (this.isListingPage) {
        this.isOpen = false
      }
    },
  },
  computed: {
    // Filtering the suggestion based on the input
    matches() {
      return this.suggestions.filter((obj) => {
        return obj.searchable.toLowerCase().indexOf(this.selection.toLowerCase()) >= 0
      })
    },
    // The flag
    openSuggestion() {
      return this.selection !== ""
          && this.matches.length !== 0
          && this.isOpen === true
    }
  }
}
</script>
